"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tokenCategorySortIndex = exports.tokenCategoryLabel = exports.tokenCategories = exports.categoryNameAt = void 0;
// 토큰 이름의 단어를 의미 그룹으로 묶어, 서로 다른 그룹의 경계에서만 구분자를 '.'으로 바꿔 구조를 드러낸다.
// 위에서부터 먼저 매칭되는 그룹을 사용하므로 더 구체적인 그룹을 앞에 둔다.
// state는 dimension·surface에 적용되는 변형이므로 겹치는 단어가 없어 순서와 무관하고,
// surface는 border-width처럼 dimension 단어(width)를 포함하는 합성어를 갖고 있어 dimension보다 앞에 둔다.
const WORD_CATEGORIES = [
    {
        name: 'state',
        words: ['hover', 'active', 'focus', 'disabled', 'selected', 'pressed', 'checked'],
    },
    {
        name: 'surface',
        words: [
            'border',
            'border-radius',
            'border-color',
            'border-width',
            'background-color',
            'text-color',
            'backdrop-filter',
            'shadow',
            'blur',
            'accent',
            'line-color',
            'line-width',
        ],
    },
    {
        name: 'dimension',
        words: [
            'width',
            'min-width',
            'height',
            'max-height',
            'margin',
            'padding',
            'padding-inline',
            'gap',
            'size',
            'space',
            'spacing',
            'offset',
            'text-size',
            'text-weight',
        ],
    },
];
// state는 dimension·surface에 딸린 변형이라 단독 카테고리가 아니라 base 뒤에 이어 붙인다.
const CATEGORY_DISPLAY_ORDER = ['dimension', 'surface', 'state'];
// border-radius, background-color처럼 '-'로 이어진 카테고리 단어는 조각을 이어붙인 문자열이
// 아니라, 인접한 조각들이 각 자리에 정확히 대응하는지로 판단해 엉뚱한 이웃 조각까지
// 함께 묶이지 않게 한다.
function matchesWord(parts, index, word) {
    const wordParts = word.split('-');
    const firstStart = Math.max(0, index - wordParts.length + 1);
    const starts = Array.from({ length: index - firstStart + 1 }, (_, offset) => firstStart + offset);
    return starts.some(start => wordParts.every((wordPart, offset) => parts[start + offset]?.includes(wordPart)));
}
/** 토큰 이름을 '-'로 쪼갠 조각 중 index 위치의 단어가 속한 카테고리 이름. 없으면 빈 문자열. */
function categoryNameAt(index, parts) {
    const category = WORD_CATEGORIES.find(({ words }) => words.some(word => matchesWord(parts, index, word)));
    return category?.name ?? '';
}
exports.categoryNameAt = categoryNameAt;
/** 토큰 이름이 속한 카테고리를 중복 없이 표시 순서(dimension/surface → state)로 반환한다. */
function tokenCategories(name) {
    const parts = name.split('-');
    const found = new Set(parts.map((_, index) => categoryNameAt(index, parts)));
    return CATEGORY_DISPLAY_ORDER.filter(category => found.has(category));
}
exports.tokenCategories = tokenCategories;
function capitalize(word) {
    return `${word[0].toUpperCase()}${word.slice(1)}`;
}
/** 카테고리 태그에 표시할 레이블. "Surface", "Dimension-State"처럼 합성 카테고리는 '-'로 잇는다. */
function tokenCategoryLabel(name) {
    return tokenCategories(name).map(capitalize).join('-');
}
exports.tokenCategoryLabel = tokenCategoryLabel;
// 같은 카테고리 토큰을 표시 순서(dimension → surface → state)로 묶어 정렬할 때 쓰는 키.
// 카테고리가 없는 토큰은 맨 뒤로 보낸다.
function tokenCategorySortIndex(name) {
    const [primary] = tokenCategories(name);
    const index = CATEGORY_DISPLAY_ORDER.indexOf(primary);
    return index === -1 ? CATEGORY_DISPLAY_ORDER.length : index;
}
exports.tokenCategorySortIndex = tokenCategorySortIndex;
//# sourceMappingURL=data:application/json;base64,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